import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  verificationToken: null,
  deviceId: null,
  eventId: null,
  applicantId: null,
  userId: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      // Only update if the key exists in the payload.
      if (action.payload.token !== undefined) {
        state.token = action.payload.token;
      }
      if (action.payload.deviceId !== undefined) {
        state.deviceId = action.payload.deviceId;
      }
      if (action.payload.eventId !== undefined) {
        state.eventId = action.payload.eventId;
      }
      if (action.payload.applicantId !== undefined) {
        state.applicantId = action.payload.applicantId;
      }
      if (action.payload.userId !== undefined) {
        state.userId = action.payload.userId;
      }
    },
    setVerificationToken: (state, action) => {
      state.verificationToken = action.payload;
    },
    logout: (state) => {
      state.token = null;
      state.verificationToken = null;
      state.deviceId = null;
      state.eventId = null;
      state.applicantId = null;
      state.userId = null;
    },
  },
});

export const { setAuthData, setVerificationToken, logout } = authSlice.actions;
export default authSlice.reducer;
